import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import { useStateValue } from "../../StateProvider";

const StockBox = ({ stock }) => {
  const round = (n) => {
    return n ? +n.toFixed(2) : null;
  };
  const [{ token }] = useStateValue();
  const [chartSeriesData, setChartSeriesData] = useState([{ data: [] }]);
  const [logo, setLogo] = useState("");
  const [price, setPrice] = useState(-1);
  const [priceChange, setPriceChange] = useState(-1);
  const [volume, setVolume] = useState(null);
  const [marketCap, setMarketCap] = useState("");

  useEffect(() => {
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${stock?.symbol}/quote?token=${token}`
      )
      .then((res) => {
        // console.log(stock?.symbol, "pryce", res.data);
        setPrice(res.data?.latestPrice);
        setPriceChange(res.data?.change);
        setMarketCap(res.data?.marketCap);
        setVolume(res.data?.marketCap);
      })
      .catch((err) => console.log(err));

    /************ logo */
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${stock?.symbol}/logo?token=${token}`
      )
      .then((res) => {
        // console.log("logo", res.data);
        setLogo(res.data?.url);
      })
      .catch((err) => console.log(err));

    /*********historical prices */
    axios
      .get(
        ` https://cloud.iexapis.com/stable/stock/${stock?.symbol}/chart/1m?token=${token}&&chartCloseOnly=true`
      )
      .then((res) => {
        // console.log("historical price", res.data);
        let prices = res.data;
        prices = prices.map((p) => [p?.date, p?.close]);
        setChartSeriesData([{ data: prices }]);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    let timeoutid;
    async function getLatestPrice() {
      // let data = await getStock();
      // const gme = data.chart.result[0];
      // console.log(gme);
      // const prices = gme.timestamp
      //   .filter((t, i) => i % 10 == 0)
      //   .map((timestamp, index) => ({
      //     x: new Date(timestamp * 1000),
      //     y: [
      //       round(quote.open[index]),
      //       round(quote.high[index]),
      //       round(quote.low[index]),
      //       round(quote.close[index]),
      //     ],
      //   }));
      // setChartSeriesData([{ data: prices }]);
      //temporarily commented for testing
      // timeoutid = setTimeout(getLatestPrice, 5000);
    }

    // timeoutid = setTimeout(getLatestPrice, 5000);
    getLatestPrice();

    return () => {
      clearTimeout(timeoutid);
    };
  }, []);
  // useEffect(() => {
  //   console.log("real data", price, priceTime, previousPrice, chartSeriesData);
  // }, [price, priceTime, previousPrice, chartSeriesData]);
  return (
    <div className="box">
      <h5 className="heading">
        <span className="text">{stock?.symbol}</span>
      </h5>
      <h6 className="subheading">
        <span className="text">{stock?.company}</span>
      </h6>
      <div className="stock__price">
        <span className="text">${price && price}</span>
      </div>
      <span className="logo">{logo && <img src={logo} width="100%" />}</span>
      <div className="graph">
        <div className="chart__wrapper">
          <Chart
            options={options}
            series={chartSeriesData}
            type="line"
            height={140}
            width="100%"
          />
        </div>
      </div>
      <h5 className="market__cap">
        Market Cap: <b className="value">${numFormatter(marketCap)} </b>
      </h5>
    </div>
  );
};

export default StockBox;
var options = {
  series: [
    {
      name: "STOCK ABC",
      data: [],
    },
  ],
  chart: {
    type: "area",
    height: 750,
    zoom: {
      enabled: false,
    },
    toolbar: {
      autoSelected: "pan",
      show: false,
    },
  },
  // fill: {
  //   colors: ["#000000"],
  // },
  theme: {
    monochrome: {
      // enabled: true,
      // color: "#0fd68b",
      // shadeTo: "light",
      // shadeIntensity: 0.15,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    width: 3
  },

  title: {
    text: "",
    align: "left",
  },
  subtitle: {
    text: "",
    align: "left",
  },
  // labels: series.monthDataSeries1.dates,
  grid: {
    show: false,
  },
  xaxis: {
    type: "datetime",
    labels: {
      show: false,
    },
    lines: {
      show: false, //or just here to disable only x axis grids
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    opposite: true,
    labels: {
      show: false,
    },
  },
  legend: {
    horizontalAlign: "left",
  },
};
// const chart = {
//   options: {
//     plotOptions: {
//       candlestick: {
//         colors: {
//           upward: "#0fff20",
//           downward: "#ff0d40",
//         },
//       },
//     },
//     chart: {
//       type: "candlestick",
//       height: 350,
//       toolbar: {
//         autoSelected: "pan",
//         show: false,
//       },
//       zoom: {
//         enabled: false,
//       },
//     },
//     grid: {
//       show: false,
//     },

//     title: {
//       text: "",
//       align: "left",
//     },
//     xaxis: {
//       type: "datetime",
//       labels: {
//         show: false,
//       },
//       lines: {
//         show: false, //or just here to disable only x axis grids
//       },
//       axisBorder: {
//         show: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//     },
//     yaxis: {
//       tooltip: {
//         enabled: true,
//       },
//       labels: {
//         show: false,
//       },
//       lines: {
//         show: false, //or just here to disable only y axis
//       },
//     },
//   },
// };

function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num > 100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 900) {
    return num; // if value < 1000, nothing to do
  }
}
